import { useTranslate } from 'ra-core'
import { useResourceContext } from 'react-admin'

import AddressInputBase from './AddressInputBase'
import { PLACE_DETAILS_FIELD_FORMATTED_ADDRESS } from '../config/addresses'

const AddressInputMain = (props) => {
  const resource = useResourceContext()
  const translate = useTranslate()

  const getOptionLabel = (option) => {
    if (option.description) return option.description
    else if (option[PLACE_DETAILS_FIELD_FORMATTED_ADDRESS]) return option[PLACE_DETAILS_FIELD_FORMATTED_ADDRESS]
    return ''
  }

  return (
    <AddressInputBase
      getOptionLabel={getOptionLabel}
      label={translate(props.label || `resources.${resource}.fields.${props.source}`)}
      {...props}
    />
  )
}

export default AddressInputMain
